// needed to define gloabl jQuery before other imports in application.js
// see https://gorails.com/episodes/how-to-use-jquery-with-esbuild

import jquery from "jquery"
window.jQuery = jquery;
window.$ = jquery;
